/**
 * Converts theme GBP amounts to the customer's Markets currency
 * using window.Shopify.currency.rate / .active.
 */
function formatMarketMoney(shopCents) {
  const currency = window.Shopify?.currency?.active || 'GBP';
  const rate = Number.parseFloat(window.Shopify?.currency?.rate || '1') || 1;
  const amount = (shopCents * rate) / 100;

  try {
    return new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
    }).format(amount);
  } catch {
    return `${currency} ${amount.toFixed(2)}`;
  }
}

export function refreshMarketMoney(root = document) {
  root.querySelectorAll('[data-market-money]').forEach((el) => {
    const cents = Number(el.dataset.gbpAmount || 0);
    if (!Number.isFinite(cents)) return;
    const suffix = el.dataset.suffix || '';
    el.textContent = `${formatMarketMoney(cents)}${suffix}`;
  });
}

function boot() {
  refreshMarketMoney();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}

document.addEventListener('shopify:section:load', (event) => {
  refreshMarketMoney(event.target);
});
